import loadable from '@loadable/component';
import FullPageLoader from '../../components/UIElements/Loader/fullPageLoader';

export const StoreLayout = loadable(() => import('./store.layout'), {
  fallback: <FullPageLoader />,
});
